import * as React from 'react'

export const Shell: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div className="shell">{children}</div>
}
